export default __webpack_public_path__ + "static/media/puzzle_1.5f35fa73.png";